import { buildAppTakeoverConfig } from '../../build-app-takeover-config';
import type { TakeoverRuntimeBindings } from '../../build-app-takeover-config';

import { HeroBottomGradient } from './components/HeroBottomGradient';
import { ConfirmHeaderOverlay } from './components/confirm-header-overlay';
import { HeaderFlair } from './components/header-flair';
import { manifest } from './manifest';

const assets: TakeoverRuntimeBindings<typeof manifest>['assets'] = {
  menuIcon: require('./assets/menu-icon.webp'),
  menuIconActive: require('./assets/menu-icon-active.webp'),
  mealCartItemBackground: require('./assets/meal-cart-item-background.webp'),
  mealCartItem: require('./assets/meal-cart-item.webp'),
  kidsCartItemBackground: require('./assets/kids-cart-item-background.webp'),
  kidsCartItem: require('./assets/kids-cart-item.webp'),
  sectionFooter: require('./assets/section-footer.webp'),
  mealsSectionTileBackground: require('./assets/meals-section-tile-bg.webp'),
  mealsSectionTile: require('./assets/meals-section-tile.webp'),
  kidsSectionTileBackground: require('./assets/kids-menu-section-tile-bg.webp'),
  kidsSectionTile: require('./assets/kids-section-tile.webp'),
  pdpOverviewTop: require('./assets/pdp-overview-top.webp'),
  pdpOverviewBottom: require('./assets/pdp-overview-bottom.webp'),
  pdpSummaryPageBackground: require('./assets/pdp-summary-page-bg.webp'),
  pdpHeaderFlair: require('./assets/pdp-header-flair.webp'),
  checkout: require('./assets/checkout.mp4'),
  orderConfirmHeader: require('./assets/order-confirm-details-header.webp'),
  orderConfirmHeaderOverlay: require('./assets/order-confirm-details-header-overlay.webp'),
};

const components: TakeoverRuntimeBindings<typeof manifest>['components'] = {
  HeroBottomGradient,
  HeaderFlair,
  ConfirmHeaderOverlay,
};

export const mandalorian = buildAppTakeoverConfig(manifest, { assets, components });
